export const COACH_CODE = [
    {
        name: 'Career coaching',
        value: 0,
    },
    {
        name: 'Personal development planning',
        value: 1,
    },
    {
        name: 'Startup advice',
        value: 2,
    },
    {
        name: 'Mental health advice',
        value: 3,
    },
    {
        name: 'Exam prep',
        value: 4,
    },
    {
        name: 'Resume craving',
        value: 5,
    },
    {
        name: 'Interview coaching',
        value: 6,
    },
    {
        name: 'Professional upskilling',
        value: 7,
    },
    {
        name: 'Life coaching',
        value: 8,
    },
    {
        name: 'Performance coaching',
        value: 9,
    },
    {
        name: 'Relationship coaching',
        value: 10,
    },
    {
        name: 'Sales coaching',
        value: 11,
    },
    {
        name: 'Employee coaching',
        value: 12,
    },
    {
        name: 'Success coaching',
        value: 13,
    },
    {
        name: 'Transformational coaching',
        value: 14,
    },
    {
        name: 'Wellness coaching',
        value: 15,
    },
    {
        name: 'Executive coaching',
        value: 16,
    },
    {
        name: 'Leadership coaching',
        value: 17,
    },
    {
        name: 'Financial coaching',
        value: 18,
    },
    {
        name: 'Spiritual coaching',
        value: 19,
    },
    {
        name: 'Career(Onboarding, Transition, Outplacement)',
        value: 20,
    },
    {
        name: 'Corporate/Organizational',
        value: 21,
    },
    {
        name: 'Cross- Culture',
        value: 22,
    },
    {
        name: 'Executive(Leadership Development)',
        value: 23,
    },
    {
        name: 'Personal Growth',
        value: 24,
    },
    {
        name: 'Retirement Coaching',
        value: 25,
    }
]